module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc",
      "title": "Contents"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Foreword"
    }
  }, [_c('i', [_vm._v("Foreword by J. I. Packer")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface"
    }
  }, [_c('i', [_vm._v("Preface to the Expanded Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface2"
    }
  }, [_c('i', [_vm._v("Preface to the Original Edition")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1"
    }
  }, [_vm._v("1: Why Study the Bible?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2: Personal Bible Study and Private Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Hermeneutics: The Science of Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: Practical Rules for Biblical Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: Culture and the Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: Practical Tools for Bible Study")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/MoreTitlesfromIVP",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("More Titles from InterVarsity Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0